import { Typography } from "@material-ui/core";
import { InfoItem } from "../contacts/WatchContactPage";


export default function TransactionTab({ project }) {
    const transaction = project?.transactionInfo;

    return (
        <>
            <div className="d-flex align-item-center mt-5 flex-column">
                <Typography variant="h6" color="text.secondary">
                    Transaction
                </Typography>
            </div>
            <div className="d-flex align-item-center">
                <div className="col-4">
                    <InfoItem label="Route to market " value={transaction?.routeMarket} h6 />
                </div>
                <div className="col-4">
                    <InfoItem label="Expected energy sale price " value={transaction?.energyExpectedSale !== undefined ? transaction?.energyExpectedSale + ' €/MWh' : '---'} h6 />
                </div>
                <div className="col-4">
                    <InfoItem label="Contract Duration" value={transaction?.contractYears !== undefined ? transaction?.contractYears + ' years' : '---'} h6 />
                </div>
            </div>
            <div className="d-flex align-item-center">
                <div className="col-4">
                    <InfoItem label="Route to market 2" value={transaction?.routeMarket2} h6 />
                </div>
                <div className="col-4">
                    <InfoItem label="Expected energy sale price 2" value={transaction?.energyExpectedSale2 !== undefined ? transaction?.energyExpectedSale2 + ' €/MWh' : '---'} h6 />
                </div>
                <div className="col-4">
                    <InfoItem label="Contract Duration 2" value={transaction?.contractYears2 !== undefined ? transaction?.contractYears2 + ' years' : '---'} h6 />
                </div>
            </div>
            <div className="d-flex align-item-center">
                <div className="col-4">
                    <InfoItem label="Storage Revenue" value={transaction?.storageRevenue?.join(", ")} h6 />
                </div>
                <div className="col-4">
                    <InfoItem label="Deal Type" value={transaction?.dealSeeking} h6 />
                </div>
                <div className="col-4">
                    <InfoItem label="Percentage of Capital Required" value={transaction?.capitalRequired !== undefined ? transaction?.capitalRequired + ' %' : '---'} h6 />
                </div>
            </div>

        </>
    )
}